import { render, staticRenderFns } from "./earn-turn.vue?vue&type=template&id=00b4d8cb&"
import script from "./earn-turn.vue?vue&type=script&lang=js&"
export * from "./earn-turn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports